import getUnicodeFlagIcon from 'country-flag-icons/unicode';

interface CountryOption {
  value?: string;
  label?: string;
  divider?: boolean;
}

interface CountrySelectProps {
  value?: string;
  onChange: (value?: string) => void;
  options: CountryOption[];
  disabled?: boolean;
  readOnly?: boolean;
}

export function CountrySelect({
  value,
  onChange,
  options,
  disabled,
}: CountrySelectProps) {
  const countries = options.filter((opt) => !opt.divider && opt.value);

  return (
    <select
      value={value || ''}
      onChange={(e) => {
        const val = e.target.value;
        onChange(val === 'ZZ' ? undefined : val);
      }}
      disabled={disabled}
      className="h-12 w-[130px] rounded-md border border-outline bg-white px-3 text-base focus:border-accent-purple focus:ring-accent-purple focus:outline-none"
    >
      {countries.map((opt) => (
        <option key={opt.value} value={opt.value!}>
          {getUnicodeFlagIcon(opt.value!)} {opt.label}
        </option>
      ))}
    </select>
  );
}
